import script from "./CampaignInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignInfo.vue?vue&type=script&setup=true&lang=js"

import "./CampaignInfo.vue?vue&type=style&index=0&id=afe62958&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afe62958"]])

export default __exports__